/* global appData ui */ // appData declared in the view
import addClickTrackingHandler from './utils/addClickTrackingHandler';
import debounce from './utils/debounce';
import events from './utils/events';
import fireEvent from './utils/fireEvent';
import hideLoading from './utils/loading/hideLoading';
import redirectIfNotInFrame from './utils/redirectIfNotInFrame';
import sendMessageToParent from './utils/sendMessageToParent';
import showLoading from './utils/loading/showLoading';

($ => {
	$(() => {
		redirectIfNotInFrame();
		addClickTrackingHandler();
		sendMessageToParent(events.PASSWORD_RESET_START);
		let height = $('body').height();
		sendMessageToParent(events.FRAME_RESIZE, { height });
		const sendHeightToParent = debounce(() => {
			const newHeight = $('body').height();
			if (newHeight !== height) {
				height = newHeight;
				sendMessageToParent(events.FRAME_RESIZE, { height });
			}
		}, 20);
		let userId;

		// Initial password reset request form
		let passwordResetFormProcessing = false;
		const $passwordResetForm = document.getElementById('passwordResetForm');
		const emailValidator = ui.validator($passwordResetForm, {
			fields: {
				emailAddress: { required: true, errorLocation: 'below', pattern: 'email', when: 'submit' }
			},
			onSubmit: function submitHandler({ valid }) {
				if (!valid || passwordResetFormProcessing) {
					sendMessageToParent(events.PASSWORD_RESET_EMAIL_MALFORMED);
					return false;
				}
				passwordResetFormProcessing = true;
				const $continueBtn = $('#resetContinueBtn');
				showLoading($continueBtn);
				const emailAddress = $('#emailAddress').val();
				const errorLabel = document.querySelector(`label[for="emailAddress"]`);
				$.ajax({
					type: 'POST',
					url: `${appData.appPath}/signin/frame/requestResetToken`,
					data: {
						email: emailAddress
					},
					dataType: 'json',
					success(res) {
						switch (res.result) {
							case 'OK': {
								$('#resetBody').addClass('noDisplay');
								$('#tokenBody').removeClass('noDisplay');
								sendMessageToParent(events.PASSWORD_RESET_EMAIL_SENT, { email: emailAddress });
								break;
							}
							case 'EMAIL_NOT_SENT_TOO_MANY_REQUESTS': {
								sendMessageToParent(events.PASSWORD_RESET_TOO_MANY_REQUESTS);
								resetEmailForm($continueBtn);
								break;
							}
							default: {
								sendMessageToParent(events.PASSWORD_RESET_SERVER_ERROR);
								emailValidator.updateValidationMessage('emailAddress', false, errorLabel.getAttribute('data-error-1'));
								resetEmailForm($continueBtn);
								break;
							}
						}
					},
					error({ status }) {
						if (status > 0) {
							sendMessageToParent(events.PASSWORD_RESET_SERVER_ERROR);
						} else {
							sendMessageToParent(events.PASSWORD_RESET_NETWORK_ERROR);
						}
						resetEmailForm($continueBtn);
					}
				});
			}
		});

		function resetEmailForm($continueBtn) {
			passwordResetFormProcessing = false;
			hideLoading($continueBtn);
		}

		// Enter your code/token form
		let passwordTokenFormProcessing = false;
		function resetTokenForm($continueBtn) {
			passwordTokenFormProcessing = false;
			hideLoading($continueBtn);
		}
		const $passwordTokenForm = document.getElementById('passwordTokenForm');
		const tokenErrorLabel = document.querySelector('label[for="resetToken"]');
		const tokenValidator = ui.validator($passwordTokenForm, {
			fields: {
				resetToken: {
					required: true,
					errorLocation: 'below',
					pattern: function pattern({ value, field }) {
						if (!/^[A-Z0-9]{6,8}$/.test(value)) {
							tokenValidator.updateValidationMessage(field.id, false, tokenErrorLabel.getAttribute('data-error'));
							return false;
						}
						return true;
					},
					when: 'submit'
				}
			},
			onSubmit: function submitHandler({ valid }) {
				if (!valid || passwordTokenFormProcessing) {
					sendMessageToParent(events.PASSWORD_RESET_CODE_MALFORMED);
					return false;
				}
				passwordTokenFormProcessing = true;
				const $continueBtn = $('#tokenContinueBtn');
				showLoading($continueBtn);
				$.ajax({
					type: 'POST',
					url: `${appData.appPath}/signin/frame/validateResetToken`,
					data: {
						email: $('#emailAddress').val(),
						token: $('#resetToken')
							.val()
							.trim()
					},
					dataType: 'json',
					success(data) {
						switch (data.status) {
							case 'SUCCESS': {
								fireEvent('reset password : code verify : success');
								// If there is only 1 account, skip the account picker
								if (data.accounts.length < 2) {
									userId = data.accounts[0].userId;
									$('#tokenBody').addClass('noDisplay');
									$('#passwordBody').removeClass('noDisplay');
									sendMessageToParent(events.PASSWORD_RESET_CODE_VALID);
									return;
								}
								// Else hydrate the account form and listen for account selected
								$('#accountForm')
									.get(0)
									.hydrate(data.accounts);
								$('#accountForm').one('ACCOUNT_SELECTED', (e, user) => {
									userId = user.userId;
									$('#accountsBody').addClass('noDisplay');
									$('#passwordBody').removeClass('noDisplay');
									sendMessageToParent(events.PASSWORD_RESET_MULTI_ACCOUNT_SELECTED);
								});

								$('#tokenBody').addClass('noDisplay');
								$('#accountsBody').removeClass('noDisplay');
								sendMessageToParent(events.PASSWORD_RESET_CODE_VALID_MULTI_ACCOUNT);
								break;
							}
							case 'EXPIRED_TOKEN': {
								fireEvent('reset password : code verify : code expired');
								sendMessageToParent(events.PASSWORD_RESET_CODE_EXPIRED);
								$('#tokenBody').addClass('noDisplay');
								$('#codeExpiredBody').removeClass('noDisplay');
								break;
							}
							default: {
								fireEvent('reset password : code verify : failed');
								resetTokenForm($continueBtn);
								sendMessageToParent(events.PASSWORD_RESET_CODE_INVALID);
								tokenValidator.updateValidationMessage('resetToken', false, tokenErrorLabel.getAttribute('data-error'));
							}
						}
					},
					error({ status }) {
						if (status > 0) {
							sendMessageToParent(events.PASSWORD_RESET_SERVER_ERROR);
						} else {
							sendMessageToParent(events.PASSWORD_RESET_NETWORK_ERROR);
						}
						resetTokenForm($continueBtn);
					}
				});
			}
		});

		// Bind to resend email
		$('#resetTokenResend').click(() => {
			window.location.reload();
		});

		// Set new password form
		let passwordFormProcessing = false;
		const $passwordForm = document.getElementById('passwordForm');
		ui.validator($passwordForm, {
			fields: {
				password1: {
					pattern: 'password',
					required: true
				},
				password2: {
					required: true,
					errorLocation: 'below',
					match: 'password1'
				}
			},
			onSubmit: function submitHandler({ valid }) {
				if (!valid || passwordFormProcessing) {
					fireEvent('reset password : new password : unmatch');
					sendMessageToParent(events.PASSWORD_RESET_PASSWORD_MALFORMED);
					return false;
				}
				passwordFormProcessing = true;
				const $continueBtn = $('#passwordContinueBtn');
				showLoading($continueBtn);
				$.ajax({
					type: 'POST',
					url: `${appData.appPath}/signin/frame/resetPassword`,
					data: {
						email: $('#emailAddress').val(),
						userId,
						token: $('#resetToken')
							.val()
							.trim(),
						password: $('#password1').val()
					},
					dataType: 'json',
					success() {
						$('#passwordBody').addClass('noDisplay');
						$('#completeBody').removeClass('noDisplay');
						fireEvent('reset password : complete');
						sendMessageToParent(events.PASSWORD_RESET_PASSWORD_SAVED);
					},
					error({ status }) {
						if (status > 0) {
							sendMessageToParent(events.PASSWORD_RESET_SERVER_ERROR);
						} else {
							sendMessageToParent(events.PASSWORD_RESET_NETWORK_ERROR);
						}
						passwordFormProcessing = false;
						hideLoading($continueBtn);
					}
				});
			}
		});

		// Send messages for height adjustments
		const heightObserver = new MutationObserver(sendHeightToParent);
		heightObserver.observe(document.body, { attributes: true, childList: true, subtree: true });

		window.addEventListener('resize', sendHeightToParent);
	});
})(jQuery);
